import useTranslation from "@/hook/useTranslation";
import React from "react";
import { BsGraphUpArrow } from "react-icons/bs";
import { FiPercent } from "react-icons/fi";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import { LuCalendarClock } from "react-icons/lu";

export default function KeyHighlightLayout() {
  const { t } = useTranslation();
  const highlights = [
    {
      icon: <FiPercent size={32} className="text-[#26c48c]" />,
      title: t("keyHighlightsContentTitle1"),
      desc: t("keyHighlightsContentDescription1"),
    },
    {
      icon: <HiOutlineClipboardCheck size={32} className="text-[#26c48c]" />,
      title: t("keyHighlightsContentTitle2"),
      desc: t("keyHighlightsContentDescription2"),
    },
    {
      icon: <LuCalendarClock size={32} className="text-[#26c48c]" />,
      title: t("keyHighlightsContentTitle3"),
      desc: t("keyHighlightsContentDescription3"),
    },
  ];

  return (
    <div className="key-highlight-layout">
      <div className="content">
        <h2 className="text-title">
          <BsGraphUpArrow style={{ marginRight: 8 }} color={"#26c48c"} />
          {t("keyHighlights")}
        </h2>
        <h1 className="key-highlight-title"> {t("keyHighlightstitle")}</h1>
        {/*TODO:Create card 3 card in one line */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {highlights.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 text-center shadow-md text-gray-800 hover:scale-[1.05] transition-transform card"
            >
              <div className="mb-4 flex justify-center">
                <div className="icon-wrapper">
                  <div className="icon-background">{item.icon}</div>
                </div>
              </div>
              <div className="title-card">{item.title}</div>
              <p className="text-sm text-gray-600 description">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
